/**
 * @description  Stylesheet list
 */

export default Object.freeze({
  TEASER: 'teaser',
  EDITOR: 'editor',
  FULLFRAME: 'fullframe',
  SATISFACTION: 'satisfaction',
  PRINT: 'print',
  SIDEBAR: 'sidebar',
  PREQUALIFICATION_BOT: 'botPrequalification',
  PREQUALIFICATION_CHAT: 'chatPrequalification',
})
